// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingIndicator_root__1PgmH","container":"LoadingIndicator_container__1WNil","label":"LoadingIndicator_label__fpdqU"};